export interface SignatureAlertNotif {
  id: string;
  type: string;
  is_read: boolean;
  title: string;
  message: string;
  metadata: Record<string, unknown> | null;
}

export function circuitIdFromMetadata(metadata: Record<string, unknown> | null): string | null {
  const id = metadata?.circuit_id;
  return typeof id === 'string' && id.length > 0 ? id : null;
}

/** Premier snapshot (seen === null) : baseline, zéro toast. Ensuite : nouvelles signature_to_sign non lues. */
export function nextSignatureToSignAlerts(
  seen: ReadonlySet<string> | null,
  incoming: readonly SignatureAlertNotif[],
): { alerts: SignatureAlertNotif[]; nextSeen: Set<string> } {
  const nextSeen = new Set(seen ?? []);
  for (const n of incoming) nextSeen.add(n.id);
  if (seen === null) {
    return { alerts: [], nextSeen };
  }
  const alerts = incoming.filter(
    (n) => n.type === 'signature_to_sign' && !n.is_read && !seen.has(n.id),
  );
  return { alerts, nextSeen };
}
